import axios from './axios'

export const validateCoupon = async ({ code, subscriptionId, israel }) => {
  const { data } = await axios.post('/coupon/validate', {
    code,
    ...(subscriptionId ? { subscriptionId, israel } : {}),
  })
  return data
}

export const getCoupons = async () => {
  const { data } = await axios.get('/coupon')
  return data
}

export const storeCoupon = async payload => {
  const { data } = await axios.post('/coupon', payload)
  return data
}

export const updateCoupon = async payload => {
  const { data } = await axios.put(`/coupon/${payload._id}`, payload)
  return data
}

export const destroyCoupon = async id => {
  await axios.delete(`/coupon/${id}`)
}

export const getCouponUsages = async id => {
  const { data } = await axios.get(`/coupon/${id}/usages`)
  return data
}
